module.exports = __webpack_public_path__ + "img/m-xinxichaxun.ed40d091.svg";